// SectionTitle.tsx — Phase 11 Step 3 Block 5
// Section-Heading für Feed-Rows (Titel + optionaler Subtitle + optionaler "See all"-Link).
// Source-of-truth: Scrolly Platform.html:1007–1030.

import { FONT_DISPLAY, PINK, VARIANT } from "../../lib/tokens";
import { useVariant } from "../../hooks/useVariant";

// Inline-Chevron: kein Reuse außerhalb dieser Datei → kein Icons.tsx-Export.
function ChevronRight({ size = 14 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M9 6l6 6-6 6" />
    </svg>
  );
}

export type SectionTitleProps = {
  title: string;
  subtitle?: string;
  /** Optionaler Link-Label rechts ("Alle ansehen" o.ä.). */
  more?: string;
};

export function SectionTitle({ title, subtitle, more }: SectionTitleProps) {
  const { variant } = useVariant();
  const v = VARIANT[variant];

  return (
    <div
      style={{
        display: "flex",
        alignItems: "baseline",
        justifyContent: "space-between",
        marginTop: 56,
        marginBottom: 18,
        gap: 12,
      }}
    >
      <div>
        <h2
          style={{
            fontFamily: FONT_DISPLAY,
            color: v.text,
            fontSize: 34,
            fontWeight: 500,
            margin: 0,
            letterSpacing: -0.5,
            lineHeight: 1.1,
          }}
        >
          {title}
        </h2>
        {subtitle && (
          <div
            style={{
              color: v.muted,
              fontSize: 14,
              marginTop: 4,
            }}
          >
            {subtitle}
          </div>
        )}
      </div>
      {more && (
        <button
          type="button"
          onClick={(e) => e.preventDefault()}
          style={{
            border: "none",
            background: "transparent",
            color: PINK,
            fontSize: 13.5,
            fontWeight: 600,
            cursor: "pointer",
            fontFamily: "inherit",
            display: "flex",
            alignItems: "center",
            gap: 4,
          }}
        >
          {more} <ChevronRight size={14} />
        </button>
      )}
    </div>
  );
}
